module.exports = __webpack_public_path__ + "static/media/widgetImage.a8e7a7c2.png";